import ModalEdit from './ModalEdit';

export default ModalEdit;